var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPalletBoxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 256H288C306 256 320 242 320 224V32C320 14 306 0 288 0H96C78 0 64 14 64 32V224C64 242 78 256 96 256ZM416 256H544C562 256 576 242 576 224V96C576 78 562 64 544 64H416C398 64 384 78 384 96V224C384 242 398 256 416 256ZM624 384C633 384 640 377 640 368V336C640 327 633 320 624 320H16C7 320 0 327 0 336V368C0 377 7 384 16 384H64V448H16C7 448 0 455 0 464V496C0 505 7 512 16 512H624C633 512 640 505 640 496V464C640 455 633 448 624 448H576V384H624ZM288 448H128V384H288V448ZM512 448H352V384H512V448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletBoxes);
export default __webpack_public_path__ + "static/media/pallet-boxes.4b9a18817e96c7834d7a9547cc99970d.svg";
export { ForwardRef as ReactComponent };